module.exports = __webpack_public_path__ + "static/office-outside-narrow-441f8b3ee017a1dd8b84e91fcdadd5c4.jpg";